import React, { useEffect, useState, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { TableBox, SearchFilter, Paging } from '../../components';
import { usePagination, useFilter } from '../../hooks';
import { SnackbarContext } from '../../contexts';
import Button from '@mui/material/Button';
import Handler from '../../Handler';
import API from '../../api';

export const ForwardContractListPage = (props) => {
  const history = useHistory();
  const { updateSnackbar } = useContext(SnackbarContext);
  const [list, setList] = useState(null);
  const [header, setHeader] = useState([
    {
      key: 'seq',
      align: 'center',
      text: 'No',
      style: {
        minWidth: 100,
      },
    },
    {
      key: 'contractNumber',
      align: 'center',
      text: '계약번호',
      style: {
        minWidth: 120,
      },
    },
    {
      key: 'contractName',
      align: 'center',
      text: '결제자(기업명)',
      style: {
        minWidth: 120,
      },
    },
    {
      key: 'project',
      align: 'center',
      text: '사업ID',
      style: {
        minWidth: 120,
      },
      render: (value) => {
        return value.id;
      },
    },
    {
      key: 'project',
      align: 'center',
      text: '사업명',
      style: {
        minWidth: 200,
      },
      render: (value) => {
        return (
          <div style={{ maxWidth: 200 }} className='ellipsis-text'>
            <span>{value.title}</span>
          </div>
        );
      },
    },
    {
      key: 'orderAmount',
      align: 'center',
      text: '총 계약수량(톤)',
      style: {
        minWidth: 200,
      },
      render: (value) => {
        return Handler.numberWithCommas(value);
      },
    },
    {
      key: 'contractAmount',
      align: 'center',
      text: '누적 구매수량(톤)',
      style: {
        minWidth: 200,
      },
      render: (value) => {
        return Handler.numberWithCommas(value);
      },
    },
    {
      key: 'orderPrice',
      align: 'center',
      text: '총 계약금액(원)',
      style: {
        minWidth: 100,
      },
      render: (value) => {
        return Handler.numberWithCommas(value) + '원';
      },
    },
    {
      key: 'totalPrice',
      align: 'center',
      text: '누적 결제금액(원)',
      style: {
        minWidth: 100,
      },
      render: (value) => {
        return Handler.numberWithCommas(value) + '원';
      },
    },
    {
      key: 'createdAt',
      align: 'center',
      text: '최근 결제일시',
      style: {
        minWidth: 100,
      },
      render: (value) => {
        return Handler.getYYYYMMDDByUnix(value);
      },
    },
    {
      key: 'status',
      align: 'center',
      text: '고정 여부',
      style: {
        minWidth: 80,
      },
      render: (value) => {
        switch (value) {
          case 'Success': {
            return '성공';
          }
          case 'Cancel': {
            return '실패';
          }
          default: {
            return 'none';
          }
        }
      },
    },
  ]);

  const [filter, onFilterChange, setFiler] = useFilter([
    {
      key: 'ordering',
      type: 'select',
      label: '정렬 타입',
      value: 'SELECT_ALL',
      menus: [
        {
          value: 'SELECT_ALL',
          label: '선택 안함',
        },
        {
          value: 'RecentPayment',
          label: '최근결제 순',
        },
        {
          value: 'AccumulateOrder',
          label: '총 계약 순',
        },
        {
          value: 'AccumulateAmount',
          label: '누적 구매 순',
        },
      ],
    },
    {
      key: 'status',
      type: 'select',
      label: '정렬 타입',
      value: 'SELECT_ALL',
      menus: [
        {
          value: 'SELECT_ALL',
          label: '선택 안함',
        },
        {
          value: 'Success',
          label: '성공',
        },
        {
          value: 'Cancel',
          label: '취소',
        },
      ],
    },
    {
      key: 'searchType',
      type: 'select',
      label: '검색 종류',
      value: 'CompanyName',
      menus: [
        {
          value: 'CompanyName',
          label: '회사명',
        },
        {
          value: 'OrderNumber',
          label: '계약번호',
        },
        {
          value: 'ContractNumber',
          label: '주문번호',
        },
        {
          value: 'ProjectId',
          label: '사업ID',
        },
        {
          value: 'ProjectTitle',
          label: '사업명',
        },
      ],
    },
    {
      key: 'searchValue',
      type: 'input',
      label: '검색 값',
      value: '',
      inputType: 'text',
    },
  ]);
  const [page, totalPage, totalCount, onPageChange, setPage, setTotalPage, setTotalCount] = usePagination(0, 9);

  const tableCallback = (type, index) => {
    console.log('tableCallback type', type);
    console.log('tableCallback index', index);
  };

  const tableRowClick = (index) => {
    console.log('tableRowClick index', index);
    let target_seq = list[index].seq;
    console.log('tableRowClick target_seq', target_seq);

    history.push('/trading/contract_detail/' + target_seq);
  };

  const onSearch = (body) => {
    console.log('onSearch', body);
    requestNewList(0);
  };

  useEffect(() => {
    console.log('page effect', page);
    requestNewList();
  }, [page]);

  const requestNewList = (init_page) => {
    let body = Handler.filterToBody(filter);
    console.log('page body', body);
    API.Trading.GetContractList({
      ...body,
      page: init_page ? init_page : page,
      size: Handler.VARIABLES.PAGE_LIMIT,
    }).then(
      (res) => {
        console.log('res', res);
        let result = res.data;
        setList(result.content);
        setTotalPage(result.totalPages);
      },
      (err) => {
        console.log('err', err);
        updateSnackbar({
          type: 'error',
          open: true,
          message: err.data.message,
        });
      },
    );
  };

  const requsetAdd = () => {
    console.log('requsetAdd');
    history.push('/trading/contract_add');
  };

  console.log('list', list);

  return (
    <article className='basic-page'>
      <section className='content-header__container'>
        <header>
          <h3>기업 선도거래 계약 목록</h3>
        </header>
        <div className='button__box'>
          <Button variant='contained' onClick={requsetAdd}>
            추가
          </Button>
        </div>
      </section>
      <section className='filter__container'>
        <SearchFilter data={filter} onChange={onFilterChange} onSearch={onSearch}></SearchFilter>
      </section>
      <section className='table__container'>
        <TableBox data={list} header={header} rowClick={tableRowClick} callback={tableCallback}></TableBox>
      </section>
      <section className='paging__container'>
        <Paging page={page} totalPage={totalPage} onChange={onPageChange}></Paging>
      </section>
    </article>
  );
};
